import both from "./both";
import complement from "./complement";
import isInteger from "./isInteger";
import isOdd from "./isOdd";

const isEven = both(isInteger, complement(isOdd));

export default isEven;
